<template>
  <v-app>
    <section id="page-wrapper">
      <!-- if you want to change certain things about the VueRssFeed go to the node module and change code in the VueRssFeed.vue, Feed.vue and Article.vue files -->
      <!-- side menu & header toolbar comented out for relevant casting start -->
      <!-- <section id="menu-wrapper" :class="{ 'menu-expanded' : $store.state.menuOpen }">
        <side-menu></side-menu>
      </section>

      <section id="content-wrapper" :class="{ 'menu-expanded' : $store.state.menuOpen }">
        <v-toolbar style="z-index: 999;" class="header-toolbar" :class="{ 'menu-expanded' : $store.state.menuOpen }" :color="companyPrimaryColor" fixed dark>
          <v-toolbar-title class="white--text">Relevant Casting</v-toolbar-title>
        </v-toolbar> -->

<!-- <v-card-text></v-card-text> -->
      <div v-for="(slide, index) in casting" :key="index" v-show="slide.status == 'show'"  class="ma-0 pa-0">
        <v-container class="relevant-casting-container ma-0 pa-0" grid-list-xl fluid >
            <v-layout wrap  class="ma-0 pa-0">
            <v-flex xl7 md7 xs7 class="ma-0 pa-0" >
              <v-card dark color="primary ma-0 pa-0">
                <v-img
                  v-bind:height="maxWindowHeight"
                  class="img"
                  :src="slide.Image"
                  alt="no picture"
                ></v-img>
              </v-card>
            </v-flex>
            <v-flex d-flex xl5 md5 xs5>
              <v-card flat color="#f6f7fb">
                <v-card-title><h2 class="castTitle">{{slide.title}}</h2></v-card-title>
              <v-card-text  >posted on: {{slide.startDate.seconds | moment("DD-MM-YYYY")}} <br> posted by: {{slide.uploadedBy}} </v-card-text>
              <v-card-text  class="text-left"></v-card-text>
                <v-card-text>
                  <div v-html="slide.description" class="description"></div> 
                </v-card-text>
              </v-card>
            </v-flex>
            <v-progress-linear
              class="progress ma-0 pa-0"
              v-model="progressValue"
              height= 12px
            ></v-progress-linear>
            </v-layout>
          </v-container>
      </div>
      </section>
    </v-app>
  </template>

<script>
 
import firebase from "firebase/app";
import { bus } from "../main";
import db from "../firebase/init";
import moment from "moment";

export default {
  name: "RelevantPlayer",
  props: ["compId","compIdPreview","previewHeight"],
  data: () => ({
    casting: [],
    value: 0,
    progressValue: 0,
    interval: 0,
    activeComp: "",
    activeCompData: [],
    maxWindowHeight: 0,
    currentCastingIndex: null,
    toPreviousSlide: false,
  }),

  created() {
    this.loadCasting()
    this.maxHeight()
    bus.$on("updateWindowHeight", this.maxHeight);
    bus.$on("previewPrevious", this.previousSlide);
    bus.$on("previewNext", this.nextSlide);
    bus.$on("previewPlay", this.playSlide);
    bus.$on("previewPause", this.pauseSlide);
    bus.$on("reloadCasting", this.loadCasting);   
  },
 
  methods: {
    
    maxHeight() {
      let maxWindowHeight;
      let allowedHeight = 0;
      // Get preview height ratio if Relevant Player is loaded in Previewmode
      if(this.previewHeight){
        this.maxWindowHeight = this.previewHeight - 12
      } else{
        let totalWindowHeight = window.innerHeight;
        allowedHeight = totalWindowHeight - 12 ;
        this.maxWindowHeight = allowedHeight;
      }
    },

    loadActiveCompData() {
      this.activeCompData = [];
      db.collection("companies")
        .doc(this.compId)
        .get()
        .then(doc => {      
          this.activeCompData = doc.data();
        })
        .catch(error => {
          this.loading = false;
        });
    },

    nextSlide(){
      this.value = 100
    },

    previouSlide(){
      this.toPreviousSlide = true
      this.value = 100
    },

    pauseSlide(){
      this.value = 200
    },

    playSlide(){
      this.value = this.progressValue
    },

    showCasts(startindex){
      this.currentCastingIndex = startindex
      
      let slideBefore = 0;
      if(startindex > 0 ) {
        slideBefore = startindex - 1;
      } else {
        slideBefore = this.casting.length - 1
      }

      let slideshow = new Promise((resolve, reject) => {
        this.value = 0
        this.progressValue = 0
        this.casting[slideBefore].status = 'hide';
        this.casting[this.currentCastingIndex].status = 'show';
        let duration = this.casting[this.currentCastingIndex].delay;
        let percentage = (this.casting[this.currentCastingIndex].delay / 100);
       
        let slideInterval = setInterval(() => {
          this.value ++;
          if(this.value < 150){
            this.progressValue++
          }         
          if(this.value >= 100 && this.value < 150 ) {
            duration = 0;
            percentage = 0;
            clearInterval(slideInterval);
            resolve()      
          }
        }, percentage)
      })
      .then(()=>{
        let nextIndex
        // Check if we are going to the next or Previous
        if(this.toPreviousSlide == true){
          // Going to previous
          if(startindex > 0 ) {
            nextIndex = startindex - 1
            this.showCasts(nextIndex)
          } else {
            this.showCasts(this.casting.length - 1)
          }
          this.toPreviousSlide = false
        }
        else {
          // Going to next
          if(startindex < this.casting.length - 1 ) {
            nextIndex = startindex + 1
            this.showCasts(nextIndex)
          } else {
            this.showCasts(0)
          }
        }
      })
    },

    loadCasting() {
      // plaatje laden.
      let today = moment();
      today.unix(); //=> 1510598962

      let companyId;
      if(this.compId){
        companyId = this.compId
      }else if(this.compIdPreview){
        companyId = this.compIdPreview
      }
     
      today.format('DD/MM/YYYY'); //=> '2017-11-13T13:50:02-05:00'
      console.log(this.compId)

      // let getDateToday = moment().unix()
      let getDateToday = new Date()
      console.log("date", getDateToday);
      // db.collection("Casting").orderBy("createDate", "desc")
      db.collection("Casting").where("startDate", "<=", getDateToday)
      db.collection("Casting").where("endDate", ">=", getDateToday)
      .where("company","==", companyId)
      .where("published", "==", true)
      .get()
      .then(snap => {
        this.casting = [];
        snap.forEach(doc => {
            let casting = doc.data();
            casting.id = doc.id;
            casting.status = "hide";
            this.casting.push(casting);
            // is never undefined for query doc snapshots
            console.log(doc.id, " => ", doc.data());
        });
        this.showCasts(0)
      })
      .catch(error => {
          console.error("Error getting documents: ", error);
      });
    },         

  },
  


  computed: {
    companyPackages() {
      return this.$store.state.companyPackages;
    },

    companyNarrowcasting() {
      if (_.includes(this.companyPackages, "narrowcasting")) {
        return true;
      } else {
        return false;
      }
    },

    companyType() {
      return this.$store.state.companyType;
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userName() {
      return this.$store.state.userName;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userCompanyName() {
      return this.$store.state.userCompanyName;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    }
  }
};
</script>

<style scoped>
/* rss feed start */
/* .rss-feed {
 z-index: 0;
 width: 100%;
 bottom:0;
 min-height: 100px;	
 height: auto;
 overflow: hidden;
 position: fixed;
 align-items: center;
 justify-content: center;
 display: flex;
} */
/* rss feed end */

.logo {
 background: rgb(246, 247, 251);
 height: 100px;
 width: 100px;
 z-index: 10;
 position: fixed;
}

.castTitle {
  font-size: 40px;
}

.description {
  font-size: 20px;
}
/* .img {
  max-height: 1100px;
  min-height: 1100px;
} */

/* .relevant-casting-container{
  max-height: 1100px;
  min-height: 1100px;
} */
</style>

